// Lib
import React from 'react';
import { Button as RomaButton } from '@milanote/roma';
import { EditorToolbar } from '@milanote/roma/application';

// Components
import ImageModalBackgroundRemovalButton from './ImageModalBackgroundRemovalButton';

// Hooks
import { useTranslator } from '../../../../../components/i18n/useTranslator';

// Utils
import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';

// Types
import type { ImMNElement, MNImageContent } from '../../../../../../common/elements/elementModelTypes';
import type { BackgroundRemovalProgress } from './imageModalBackgroundRemovalProgressTypes';

type ImageModalV2BackgroundToolbarProps = {
    element: ImMNElement;
    cropSourceImage: MNImageContent;
    largestImageUrl?: string;
    imageType: string;
    progress: BackgroundRemovalProgress | null;
    setProgress: (progress: BackgroundRemovalProgress | null) => void;
    disabled: boolean;
    stagedActive: boolean;
    onChangeStagedActive: (active: boolean) => void;
    onCancelClick: () => void;
    onSaveClick: () => void;
};

const ImageModalV2BackgroundToolbar: React.FC<ImageModalV2BackgroundToolbarProps> = ({
    element,
    cropSourceImage,
    largestImageUrl,
    imageType,
    progress,
    setProgress,
    disabled,
    stagedActive,
    onChangeStagedActive,
    onCancelClick,
    onSaveClick,
}) => {
    const translate = useTranslator('popup', 'imageModal.editor');
    const drawingTranslate = useTranslator('popup', 'drawing');
    const elementId = getElementId(element);

    return (
        <EditorToolbar.Shell>
            <EditorToolbar.List>
                {largestImageUrl && (
                    <ImageModalBackgroundRemovalButton
                        element={element}
                        elementId={elementId}
                        cropSourceImage={cropSourceImage}
                        largestImageUrl={largestImageUrl}
                        imageType={imageType}
                        progress={progress}
                        setProgress={setProgress}
                        disabled={disabled}
                        stagedActive={stagedActive}
                        onChangeStagedActive={onChangeStagedActive}
                    />
                )}

                <EditorToolbar.Divider type="spacer" />

                <div className="flex shrink-0 items-center gap-sm">
                    <RomaButton color="secondary" onClick={onCancelClick}>
                        {drawingTranslate('discard')}
                    </RomaButton>

                    <RomaButton onClick={onSaveClick} isDisabled={disabled}>
                        {translate('save')}
                    </RomaButton>
                </div>
            </EditorToolbar.List>
        </EditorToolbar.Shell>
    );
};

export default ImageModalV2BackgroundToolbar;
